// import React, { Suspense, lazy, useEffect, useRef } from 'react';
// import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';
// import { AnimatePresence, motion } from 'framer-motion';
// import './index.css';
// import Navbar from './components/Navbar';
// import Footer from './components/Footer';
// import LoadingScreen from './components/LoadingScreen';
// import { AuthProvider } from './context/AuthContext';

// const Home        = lazy(() => import('./pages/Home'));
// const Menu        = lazy(() => import('./pages/Menu'));
// const Reservation = lazy(() => import('./pages/Reservation'));
// const About       = lazy(() => import('./pages/About'));
// const Gallery     = lazy(() => import('./pages/Gallery'));
// const Contact     = lazy(() => import('./pages/Contact'));

// function CustomCursor() {
//   const dot  = useRef(null);
//   const ring = useRef(null);
//   useEffect(() => {
//     let mx = 0, my = 0, rx = 0, ry = 0;
//     const move = e => { mx = e.clientX; my = e.clientY; };
//     document.addEventListener('mousemove', move);
//     const tick = () => {
//       if (dot.current)  { dot.current.style.left = mx+'px'; dot.current.style.top = my+'px'; }
//       if (ring.current) { rx += (mx-rx)*0.12; ry += (my-ry)*0.12; ring.current.style.left = rx+'px'; ring.current.style.top = ry+'px'; }
//       requestAnimationFrame(tick);
//     };
//     requestAnimationFrame(tick);
//     const grow   = () => { if(ring.current){ring.current.style.transform='translate(-50%,-50%) scale(2.2)';ring.current.style.opacity='0.35';} };
//     const shrink = () => { if(ring.current){ring.current.style.transform='translate(-50%,-50%) scale(1)';ring.current.style.opacity='0.6';} };
//     const add = () => document.querySelectorAll('a,button').forEach(el=>{el.addEventListener('mouseenter',grow);el.addEventListener('mouseleave',shrink);});
//     add();
//     const obs = new MutationObserver(add);
//     obs.observe(document.body,{childList:true,subtree:true});
//     return()=>{document.removeEventListener('mousemove',move);obs.disconnect();};
//   },[]);
//   return <><div ref={dot} className="cursor-dot"/><div ref={ring} className="cursor-ring"/></>;
// }

// function AnimatedRoutes() {
//   const location = useLocation();
//   return (
//     <AnimatePresence mode="wait">
//       <motion.div key={location.pathname}
//         initial={{opacity:0,y:18}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-10}}
//         transition={{duration:0.55,ease:[0.22,1,0.36,1]}}
//       >
//         <Suspense fallback={<LoadingScreen/>}>
//           <Routes location={location}>
//             <Route path="/"            element={<Home/>}/>
//             <Route path="/menu"        element={<Menu/>}/>
//             <Route path="/reservation" element={<Reservation/>}/>
//             <Route path="/about"       element={<About/>}/>
//             <Route path="/gallery"     element={<Gallery/>}/>
//             <Route path="/contact"     element={<Contact/>}/>
//           </Routes>
//         </Suspense>
//       </motion.div>
//     </AnimatePresence>
//   );
// }

// export default function App() {
//   return (
//     <AuthProvider>
//       <BrowserRouter>
//         <CustomCursor/>
//         <Navbar/>
//         <AnimatedRoutes/>
//         <Footer/>
//         <Toaster position="top-right" toastOptions={{
//           style:{background:'#FAF3E8',color:'#2A1206',border:'1px solid rgba(124,43,14,0.25)',fontFamily:"'Cormorant Garamond',serif",fontSize:'1.05rem',borderRadius:0},
//           success:{iconTheme:{primary:'#7C2B0E',secondary:'#FAF3E8'}},
//         }}/>
//       </BrowserRouter>
//     </AuthProvider>
//   );
// }
import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AnimatePresence, motion } from 'framer-motion';
import './index.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import { AuthProvider } from './context/AuthContext';
import ProtectedPortal from './components/portal/ProtectedPortal';
import { adminApi, staffApi } from './lib/http';
import AdminAvailability from './pages/admin/AdminAvailability';
import AdminBookings from './pages/admin/AdminBookings';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminManualBooking from './pages/admin/AdminManualBooking';
import AdminScanner from './pages/admin/AdminScanner';
import AdminStaffManagement from './pages/admin/AdminStaffManagement';
import StaffCheckins from './pages/staff/StaffCheckins';
import StaffDashboard from './pages/staff/StaffDashboard';
import StaffLayout from './pages/staff/StaffLayout';
import StaffLogin from './pages/staff/StaffLogin';
import StaffProfile from './pages/staff/StaffProfile';
import StaffScanner from './pages/staff/StaffScanner';

const Home        = lazy(() => import('./pages/Home'));
const Menu        = lazy(() => import('./pages/Menu'));
const Reservation = lazy(() => import('./pages/Reservation'));
const About       = lazy(() => import('./pages/About'));
const Gallery     = lazy(() => import('./pages/Gallery'));
const Contact     = lazy(() => import('./pages/Contact'));

// ✅ Custom Cursor Component
function CustomCursor() {
  const dot  = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    let mx = 0, my = 0, rx = 0, ry = 0;

    const move = e => { 
      mx = e.clientX; 
      my = e.clientY; 
    };

    document.addEventListener('mousemove', move);

    const tick = () => {
      if (dot.current) {
        dot.current.style.left = mx + 'px';
        dot.current.style.top  = my + 'px';
      }
      if (ring.current) {
        rx += (mx - rx) * 0.12;
        ry += (my - ry) * 0.12;
        ring.current.style.left = rx + 'px';
        ring.current.style.top  = ry + 'px';
      }
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);

    const grow = () => {
      if (ring.current) {
        ring.current.style.transform = 'translate(-50%,-50%) scale(2.2)';
        ring.current.style.opacity = '0.35';
      }
    };

    const shrink = () => {
      if (ring.current) {
        ring.current.style.transform = 'translate(-50%,-50%) scale(1)';
        ring.current.style.opacity = '0.6';
      }
    };

    const add = () => {
      document.querySelectorAll('a,button').forEach(el => {
        el.addEventListener('mouseenter', grow);
        el.addEventListener('mouseleave', shrink);
      });
    };

    add();

    const obs = new MutationObserver(add);
    obs.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.removeEventListener('mousemove', move);
      obs.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={dot} className="cursor-dot" />
      <div ref={ring} className="cursor-ring" />
    </>
  );
}

// ✅ Animated Routes
function AnimatedRoutes() {
  const location = useLocation();
  const isPortalRoute =
    location.pathname.startsWith('/admin') || location.pathname.startsWith('/staff');

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      >
        <Suspense fallback={<LoadingScreen />}>
          {!isPortalRoute ? (
            <>
              <Navbar />
              <Routes location={location}>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/reservation" element={<Reservation />} />
                <Route path="/about" element={<About />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Footer />
            </>
          ) : (
            <Routes location={location}>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedPortal client={adminApi} mePath="/admin/auth/me" loginPath="/admin/login">
                    <AdminLayout />
                  </ProtectedPortal>
                }
              >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="bookings" element={<AdminBookings />} />
                <Route path="manual-booking" element={<AdminManualBooking />} />
                <Route path="availability" element={<AdminAvailability />} />
                <Route path="staff-management" element={<AdminStaffManagement />} />
                <Route path="scanner" element={<AdminScanner />} />
              </Route>
              <Route path="/staff/login" element={<StaffLogin />} />
              <Route
                path="/staff"
                element={
                  <ProtectedPortal client={staffApi} mePath="/staff/auth/me" loginPath="/staff/login">
                    <StaffLayout />
                  </ProtectedPortal>
                }
              >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<StaffDashboard />} />
                <Route path="checkins" element={<StaffCheckins />} />
                <Route path="profile" element={<StaffProfile />} />
                <Route path="scanner" element={<StaffScanner />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
        </Suspense>
      </motion.div>
    </AnimatePresence>
  );
}

// ✅ Main App
export default function App() {
  const [isMobile, setIsMobile] = useState(false);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ResponsiveCursor isMobile={isMobile} setIsMobile={setIsMobile} />
        <AnimatedRoutes />

        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#FAF3E8',
              color: '#2A1206',
              border: '1px solid rgba(124,43,14,0.25)',
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '1.05rem',
              borderRadius: 0
            },
            success: {
              iconTheme: {
                primary: '#7C2B0E',
                secondary: '#FAF3E8'
              }
            }
          }}
        />

      </BrowserRouter>
    </AuthProvider>
  );
}

function ResponsiveCursor({ isMobile, setIsMobile }) {
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener('resize', checkScreen);

    return () => window.removeEventListener('resize', checkScreen);
  }, [setIsMobile]);

  return !isMobile ? <CustomCursor /> : null;
}
